import * as types from './mutation-types'
import store from '../../store'
import axios from 'axios'
import moment from 'moment'
import { apiErrorHandler } from '@/core/helpers/api.helpers'
import { mid } from '../../services/Mid'

/**
 * Check if the user is currently authenticated
 *
 * @param commit
 * @returns {Promise<any>}
 */
export const check = ({ commit }) => {
  return new Promise((resolve) => {
    commit(types.CHECK)
    resolve()
  })
}

export const isTokenExpired = () => {
  let isExpired = false

  if (store.state.auth.authenticated && store.state.auth.expDate) {
    let currentTime = moment()
    let expDate = moment.unix(store.state.auth.expDate)

    if (currentTime.isAfter(expDate)) {
      isExpired = true
    }
  }

  return isExpired
}

export const isMckidTokenExpired = () => {
  let isExpired = false

  if (store.state.auth.authenticated && store.state.auth.mckidToken) {
    let currentTime = moment()
    let expDate = moment.unix(store.state.auth.mckidExpDate)

    if (currentTime.isAfter(expDate)) {
      isExpired = true
    }
  }

  return isExpired
}

export const refreshedToken = ({ commit, dispatch }, data) => {
  commit(types.TOKEN_REFRESH, data)
}

/**
 * Acquire the auth token for a different company's admin user
 *
 * @param commit
 * @param companyId
 * @returns {Promise<any>}
 */
export const changeCompany = ({ commit, dispatch }, companyId) => {
  return axios.post('/api/v1/auth/switch', { 'company_id': companyId })
    .then((resp) => {
      commit(types.CHANGE_TOKEN, resp.data.token)
      commit(types.CHANGE_COMPANY, companyId)
      // Wait for all data to be fetched before redirecting
      return dispatch('app/boot', 'company', { root: true })
    })
    .catch((err) => {
      const message = err.response && 'status_message' in err.response.data
        ? err.response.data.status_message
        : 'Network Error'
      throw message
    })
}

/**
 * Acquire a token and perform authentication
 *
 * @param commit
 * @param dispatch
 * @param email
 * @param password
 * @param server
 *
 * @returns {Promise<any>}
 */
export const login = ({ commit, dispatch }, { server, payload }) => {
  commit(types.CHANGE_SERVER, server)
  return axios.post('/api/v1/auth', payload)
    .then(resp => {
      commit(types.LOGIN, resp.data)
      commit(types.CHANGE_LOGIN, resp.data.email)
      // Wait for all data to be fetched before redirecting
      return dispatch('app/boot', 'app', { root: true })
    })
    .catch(error => {
      const message = apiErrorHandler(error)
      throw message
    })
}

export const refreshLogin = ({ commit, dispatch }, { server, payload }) => {
  commit(types.CHANGE_SERVER, server)
  return axios.post('/api/v1/auth/refresh', payload)
    .then(resp => {
      commit(types.LOGIN, resp.data)
    })
    .catch(error => {
      const message = apiErrorHandler(error)
      throw message
    })
}

/**
 * Logout the current user
 *
 * @param commit
 * @returns {Promise<any>}
 */
export const logout = ({ commit }) => {
  return new Promise(async resolve => {
    Promise.all([
      store.dispatch('auth/clear'),
      store.dispatch('accounts/clear'),
      store.dispatch('tasks/clear'),
      store.dispatch('companies/clear'),
      store.dispatch('entitlements/clear'),
      await mid.logout()
    ]).then(() => {
      commit(types.LOGOUT)
      resolve()
    })
  })
}

/**
 * Reset stored data
 *
 * @param commit
 */
export const clear = ({ commit }) => {
  commit(types.CLEAR)
}

export default {
  check,
  changeCompany,
  login,
  logout,
  clear,
  isTokenExpired,
  isMckidTokenExpired,
  refreshedToken
}
